<template>
    <v-form ref="form">
      <v-layout row wrap class="objective-container">
      <!--objective ddl-->
      <v-flex xs12 md6 style="padding-top: 26px;">
        <v-select
            :items="computedObjectives"
            item-text="name"
            item-value="value"
            label="Objective"
            placeholder="Select Objective"
            :value="localRecord.value"
            @input="updateLocalRecord($event, 'localRecord')"
            :error-messages="objectiveErrors"
            @blur="onObjectiveBlur"
            v-slot="{ hasValue, isFocused }" >
        </v-select>
      </v-flex>
    <!--implementation ddl-->
    <v-layout row wrap v-if="isMobile" class="selected-values-container">
        <v-flex xs12>
        <div>
            <checkbox-list-2
            :items="sessionImplementations"
            label="Implementations"
            placeholder="Select Implementations"
            :values="localRecord2"
            :error-messages="showImplementationErrors ? implementationErrors : []"
            @blur="onImplementationBlur"
            :reset-id="isCopying"
            :validation="v.ptSessionObjectiveImplementation"
            @update="handleUpdatedObjective($event)"
            :index="index"
            ></checkbox-list-2>
        </div>
        </v-flex>
    </v-layout>
      <!--implementation ddl-->
      <v-flex v-if="!isMobile" xs6 sm12 md6>
        <checkbox-list-2
          :items="sessionImplementations"
          label="Implementations"
          placeholder="Select Implementations"
          :values="localRecord2"
          :error-messages="showImplementationErrors ? implementationErrors : []"
          @blur="onImplementationBlur"
          :reset-id="isCopying"
          :validation="v.ptSessionObjectiveImplementation"
          @update="handleUpdatedObjective($event)"
          :index="index"
        ></checkbox-list-2>
      </v-flex>
      <v-flex xs6 md6 v-if="(localRecord2.value || localRecord.value) && (isOtherImplementation(localRecord2) || localRecord.value === 'OTHER')" >
        <v-textarea v-if="localRecord.value && localRecord.value === 'OTHER'"
              label="Other Objective Description"
              placeholder="Enter Objective Description"
              v-model="localRecord.objectiveOther"
              :error-messages="showObjectiveOtherErrors ? objectiveOtherErrors : []"
              @blur="onObjectiveOtherBlur"
              v-slot="{ hasValue, isFocused }">
        </v-textarea>
      </v-flex>
      <v-flex xs6 md6 v-if="localRecord2 && isOtherImplementation(localRecord2)">
        <v-textarea
              label="Other Implementation Description"
              placeholder="Enter Implementation Description"
              counter
              :maxlength="300"
              v-model="localRecord.implementationOther"
              :error-messages="showImplementationOtherErrors ? implementationOtherErrors : []"
              @blur="onImplementationOtherBlur"
              v-slot="{ hasValue, isFocused }">
        </v-textarea>
      </v-flex>
      <!--delete button-->
      <v-flex xs12 sm12 md12 lg12 class="text-right">
        <v-layout row wrap justify-end>
          <v-tooltip :disabled="!showTooltip" top>
            <v-icon
              slot="activator"
              id="deleteIcon"
              @click="emitRemoveRecordClicked(index)"
              style="padding-top: 20px; padding-bottom: 10px;">
              mdi-delete
            </v-icon>
            <span>Delete objective</span>
          </v-tooltip>
        </v-layout>
      </v-flex>
    </v-layout>
    </v-form>
</template>
<script>
import { filterDisabledOptions } from '@/utils/service-log-utils';
import CheckboxList2 from '@/components/base/checkbox-list-2';
import Swal from 'sweetalert2';
/* eslint-disable */

export default {
    name: 'ObjectiveRepeatable',
    components: { CheckboxList2 },
    props: ['sessionObjectives', 'sessionImplementations', 'student', 'index', 'record', 'record2', 'showTooltip', 'v', 'isCopying'],
    data() {
    return {
        localRecord: { ...this.record },
        localRecord2: [...this.record2],
        showObjectiveErrors: false,
        showImplementationErrors: false,
        showObjectiveOtherErrors: false,
        showImplementationOtherErrors: false,
        addSpaceForOtherField: false
    };
    },
    computed: {
    isMobile() {
        return this.$mq === 'mobile';
    },
    isTablet() {
        return this.$mq === 'tablet';
    },
    computedObjectives() {
        return filterDisabledOptions(this.sessionObjectives, this.localRecord.value);
    },
    computedRecord: {
        get() {
        return this.record;
        },
        set(value) {
        this.$emit('update:record', value);
        this.localRecord = { ...value };
        }
    },
    // Watch for changes in the `record2` prop and update the localRecord2 accordingly
    computedRecord2: {
        get() {
        return this.record2;
        },
        set(value) {
        this.$emit('update:record2', value);
        this.localRecord2 = [...value];
        }
    },
    objectiveErrors() {
        const errors = [];
        // Check if the selected objective is empty and index is 0
        if (!this.v.ptSessionObjectives.$dirty) return errors;
        if (this.v.ptSessionObjectives.required && this.localRecord.value === '') {
            errors.push('Objective is required');
        }
        return errors;
    },
    objectiveOtherErrors() {
        const errors = [];
        // Check if the selected objective is empty and index is 0
        if (this.localRecord.value === 'OTHER' && this.localRecord.objectiveOther === '') {
        errors.push('Objective description is required');
        }
        return errors;
    },
    implementationErrors() {
        const errors = [];
        // Check if the selected implementation is empty and index is 0
        if (!this.localRecord2.value) {
        errors.push('Implementation is required');
        }
        return errors;
    },
    implementationOtherErrors() {
        const errors = [];
        // Check if there is at least one 'OTHER' value at a specific index
        const hasOtherValue = this.localRecord2.some((element) => {
            if (element.value === 'OTHER') {
            return true; // Found 'OTHER' value
            }
            return false;
        });

        if (hasOtherValue && (!this.localRecord.implementationOther || this.localRecord.implementationOther === '')) {
        errors.push('Implementation description is required');
        }
        return errors;
    }
    },
    methods: {
    handleUpdatedObjective(event) {
        this.computedRecord2 = [...event];
    },
    isOtherImplementation(implementation) {
        this.addSpaceForOtherField = implementation.filter((x) => { return x.value === 'OTHER' }).length;
        return implementation.filter((x) => { return x.value === 'OTHER' }).length;
    },

    emitRemoveRecordClicked() {
        Swal.fire({
        text: 'Are you sure you want to delete this record?',
        confirmButtonText: 'Delete',
        showCancelButton: true,
        customClass: {
            popup: 'popup-class',
            content: 'content-class',
            confirmButton: 'confirm-button-class delete'
        }
        }).then((response) => {
        if (response && response.value) this.$emit('delete:record', 'delete:record2', { index: this.index });
        });
    },
    updateLocalRecord(newValue, propKey) {
        this[propKey] = { ...this[propKey], value: newValue };
        this.$emit(propKey === 'localRecord' ? 'update:record' : 'update:record2', { ...this[propKey] });
    },
    onObjectiveBlur() {
        this.v.ptSessionObjectives.$touch();
        this.showObjectiveErrors = true;
    },
    onObjectiveOtherBlur() {
        this.showObjectiveOtherErrors = true;
    },
    onImplementationBlur() {
        this.showImplementationErrors = true;
    },
    onImplementationOtherBlur() {
        this.showImplementationOtherErrors = true;
    }
    },
    watch: {
    localRecord: {
        handler(newRecord) {
        this.$emit('update:record', { ...newRecord });
        },
        deep: true,
        immediate: true
    },
    localRecord2: {
        handler(newRecord) {
        this.localRecord2.forEach((implementation) => {
            if (!implementation.objectiveId) {
                implementation.objectiveId = this.objectiveId;
            }
        });
        this.$emit('update:record2', newRecord);
        const hasOtherValue = this.localRecord2.some((element) => {
          if (element.value === 'OTHER') {
            return true; // Found 'OTHER' value
          }
          return false;
        });
        if (!hasOtherValue) this.localRecord.implementationOther = '';
        },
        deep: true,
        immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
    .objective-container {
    margin: 20px 0 !important;
    padding: 20px 15px 0 15px;
    background-color: #fff;
    box-shadow: 0 0 8px rgba(0,0,0,0.2);
    border-radius: 10px;
    }

    #deleteIcon:hover {
    color: var(--v-error-base);
    }

    .selected-values-container {
    width: 100%;
    white-space: normal;
    overflow-x: auto;
    }

    .selected-values-container .checkbox-label {
    overflow-wrap: break-word;
    color: #fff;
    margin: 3px;
    border-radius: 4px;
    }

    /deep/ .objective-select {
    .v-select__selections {
        max-width: 96%;
        .objective-chip {
        max-width: 98%;
        .v-chip__content {
            width: 100%;
            span {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            }
        }
        }
    }
    }
</style>



// WEBPACK FOOTER //
// src/components/service-log/form/objective-repeatable.vue